import axios from "axios";
import { isEmpty } from "@/utils/String";

// 创造axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // base api url
  timeout: 3000 //请求超时
});

// 请求拦截
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

//响应拦截
// debugger
service.interceptors.response.use(
  response => {
    const res = response;
    return res;
  },

  error => {
    console.log(error, "error");
    return Promise.reject(error);
  }
);

// get请求
function get(url, args) {
  if (isEmpty(args)) {
    args = {};
  }
  if (isEmpty(url)) {
    alert("url参数不能为空");
    return null;
  }
  return new Promise(function(resolve, reject) {
    service
      .get(url, { params: args })
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

// post请求
function post(uri, args) {
  if (isEmpty(uri)) {
    alert("uri参数不能为空");
    return null;
  }
  if (isEmpty(args)) {
    args = {};
  }
  return new Promise(function(resolve, reject) {
    service
      .post(uri, args)
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export { get, post };



// WEBPACK FOOTER //
// ./src/api/request.js